(function() {
  // ---- Live Shopify pricing ----
  // cc-page-build.liquid resolves real prices (in cents) from the actual Shopify
  // products via window.CC_REAL_PRICES, so changing a price in Shopify Admin
  // updates everything here with no code edit. Hardcoded numbers below are only
  // a fallback in case a handle ever fails to resolve.
  var CC_REAL = window.CC_REAL_VARIANTS || {};
  var CC_REAL_PRICES = window.CC_REAL_PRICES || {};
  var CC_PRICE_CAMERAS = CC_REAL_PRICES.cameras || {};
  var CC_PRICE_WIRES = CC_REAL_PRICES.wireSurcharge || {};
  var CC_PRICE_KITS = CC_REAL_PRICES.popularKits || {};
  function realPrice(cents, fallbackDollars) {
    return typeof cents === "number" ? cents / 100 : fallbackDollars;
  }
  function moneyStr(n) {
    return "$" + Math.round(n).toLocaleString();
  }

  var CAMERAS = [
    { id: "ptz5", name: "5x PTZ Camera", tagline: "The Barn Specialist", numericPrice: realPrice(CC_PRICE_CAMERAS.ptz5, 600) },
    { id: "dv4", name: "4x Dual View PTZ", tagline: "Two Lenses, One Housing", numericPrice: realPrice(CC_PRICE_CAMERAS.dv4, 700) },
    { id: "ptz16", name: "16x PTZ Camera", tagline: "The Big Barn King", numericPrice: realPrice(CC_PRICE_CAMERAS.ptz16, 749) },
    { id: "ptz25", name: "25x PTZ Camera", tagline: "The Tag Reader", numericPrice: realPrice(CC_PRICE_CAMERAS.ptz25, 999) },
    { id: "dv25", name: "25x Dual View PTZ", tagline: "Zoom + Wide, One Housing", numericPrice: realPrice(CC_PRICE_CAMERAS.dv25, 1100) },
    { id: "ptz33", name: "33x PTZ Camera", tagline: "The Long Range Legend", numericPrice: realPrice(CC_PRICE_CAMERAS.ptz33, 1450) }
  ];
  var KIT = { name: "Standard Base Kit", numericPrice: realPrice(CC_REAL_PRICES.kit, 999) };
  KIT.price = moneyStr(KIT.numericPrice);
  var LOCATION_ADDON_PRICE = realPrice(CC_REAL_PRICES.locationAddon, 350);
  var WIRE_PRICE = {
    25: realPrice(CC_PRICE_WIRES[25], 35),
    50: realPrice(CC_PRICE_WIRES[50], 60),
    75: realPrice(CC_PRICE_WIRES[75], 70),
    100: realPrice(CC_PRICE_WIRES[100], 75),
    125: realPrice(CC_PRICE_WIRES[125], 85)
  };
  var POPULAR_KITS = [
    {
      id: "single-33x", name: "33x Single Camera Kit", tagline: "Long-Range · 1 Cam",
      numericPrice: realPrice(CC_PRICE_KITS["single-33x"] && CC_PRICE_KITS["single-33x"][1], 2499),
      cams: [{ camId: "ptz33", count: 1 }],
      when: "One long-range camera for open pasture or equipment yard",
      includes: [
        "One 33x PTZ — reads ear tags at 500ft",
        "Wireless bridge + 2 antennas",
        "Weatherproof control box enclosure",
        "Network video recorder (NVR)",
        "All needed cables + a spare",
        "Pre-built, programmed, tested before it ships"
      ]
    },
    {
      id: "barnyard-25x", name: "25x Barn and Yard Kit", tagline: "Yard + 2 Barn Corners · 3 Cams",
      numericPrice: realPrice(CC_PRICE_KITS["barnyard-25x"] && CC_PRICE_KITS["barnyard-25x"][1], 2999),
      cams: [{ camId: "ptz25", count: 1 }, { camId: "ptz5", count: 2 }],
      when: "Lot + two barn corners. Big coverage for one location.",
      includes: [
        "One 25x PTZ for the yard or calving lot",
        "Two 5x PTZ for the barn corners or alleyways",
        "Wireless bridge + 2 antennas",
        "Weatherproof control box enclosure",
        "Network video recorder (NVR)",
        "All needed cables + a spare"
      ]
    },
    {
      id: "ultimate", name: "The Ultimate Barn and Yard Kit", tagline: "Long-Range + Lot + 2 Barn · 4 Cams",
      numericPrice: realPrice(CC_PRICE_KITS["ultimate"] && CC_PRICE_KITS["ultimate"][1], 4599),
      cams: [{ camId: "ptz33", count: 1 }, { camId: "ptz25", count: 1 }, { camId: "ptz5", count: 2 }],
      when: "Big operations — long-range, mid-range, and barn corners covered.",
      includes: [
        "One 33x PTZ for the pasture or yard",
        "One 25x PTZ for the calving lot",
        "Two 5x PTZ for the barn corners",
        "Wireless bridge + 2 antennas",
        "Weatherproof control box enclosure",
        "Network video recorder (NVR)",
        "All needed cables + a spare"
      ]
    },
    {
      id: "4x-ptz-kit", name: "5x PTZ Kit", tagline: "Small Barn · 1 Cam",
      numericPrice: 1699,
      cams: [{ camId: "ptz5", count: 1 }],
      when: "One 5x PTZ for a small barn or a single calving pen.",
      includes: ["One 5x PTZ camera", "Wireless bridge + 2 antennas", "Weatherproof control box enclosure", "Network video recorder (NVR)", "All needed cables + a spare"]
    },
    {
      id: "25x-ptz-kit", name: "25x PTZ Kit", tagline: "Large Barn or Yard · 1 Cam",
      numericPrice: 2099,
      cams: [{ camId: "ptz25", count: 1 }],
      when: "One 25x PTZ for a large barn or wide-open calving area.",
      includes: ["One 25x PTZ camera", "Wireless bridge + 2 antennas", "Weatherproof control box enclosure", "Network video recorder (NVR)", "All needed cables + a spare"]
    },
    {
      id: "25x-4x-ptz-kit", name: "25x + 5x PTZ Kit", tagline: "Barn + Calving Area · 2 Cams",
      numericPrice: 2649,
      cams: [{ camId: "ptz25", count: 1 }, { camId: "ptz5", count: 1 }],
      when: "A 25x for the lot plus a 5x for a lower-ceiling barn.",
      includes: ["One 25x PTZ camera", "One 5x PTZ camera", "Wireless bridge + 2 antennas", "Weatherproof control box enclosure", "Network video recorder (NVR)", "All needed cables + a spare"]
    },
    {
      id: "two-25x-ptz-kit", name: "Twin 25x PTZ Kit", tagline: "Large Barns or Yards · 2 Cams",
      numericPrice: 3099,
      cams: [{ camId: "ptz25", count: 2 }],
      when: "Two 25x PTZ cameras for large barns and wide-open calving areas.",
      includes: ["Two 25x PTZ cameras", "Wireless bridge + 2 antennas", "Weatherproof control box enclosure", "Network video recorder (NVR)", "All needed cables + a spare"]
    },
    {
      id: "33x-2-4x-ptz-kit", name: "33x Barn and Yard Kit", tagline: "Long-Range + 2 Barn · 3 Cams",
      numericPrice: 3899,
      cams: [{ camId: "ptz33", count: 1 }, { camId: "ptz5", count: 2 }],
      when: "A 33x for extreme long range plus two 5x for the barn corners.",
      includes: ["One 33x PTZ camera", "Two 5x PTZ cameras", "Wireless bridge + 2 antennas", "Weatherproof control box enclosure", "Network video recorder (NVR)", "All needed cables + a spare"]
    }
  ];
  POPULAR_KITS.forEach(function(k) { k.price = moneyStr(k.numericPrice); });

  // ---- Shopify catalog wiring (variant IDs for cart/checkout) ----
  // Each camera product's variants ARE the cable-length choice (incl. "no cable"),
  // so a standalone camera pick needs no separate wire-surcharge line — the chosen
  // length is just a different variant of that same camera product.
  // Each popular-kit product's variants are the number of locations it covers (1-3);
  // its own per-camera cables still come from `wireSurcharge` as separate cart lines,
  // since the kit is bought as one bundled variant rather than individual cameras.
  var CC_VARIANTS = {
    kit: CC_REAL.kit || null, // Base Kit — id supplied by cc-page-build.liquid via all_products['base-kit']
    popularKits: {
      "single-33x": { 1: 49184342802729 }, // only ships as a 1-location bundle today
      "barnyard-25x": { 1: 49341855138089, 2: 49341855170857, 3: 49341855203625 },
      "ultimate": { 1: 49341866869033, 2: 49341866901801, 3: 49341866934569 },
      "4x-ptz-kit": { 1: 49184335986985 },
      "25x-ptz-kit": { 1: 49184181551401 },
      "25x-4x-ptz-kit": { 1: 49341796385065, 2: 49341796417833 },
      "two-25x-ptz-kit": { 1: 49341808541993, 2: 49341808574761 },
      "33x-2-4x-ptz-kit": { 1: 49341882204457, 2: 49341882237225, 3: 49341882269993 }
    },
    cameras: {
      ptz5: { none: 51447299113257, 25: 51447299146025, 50: 51447299178793, 75: 51447299211561, 100: 51447299244329, 125: 51447299277097 },
      ptz16: { none: 51447327424809, 25: 51447327457577, 50: 51447327490345, 75: 51447327523113, 100: 51447327555881, 125: 51447327588649 },
      ptz25: { none: 51447328899369, 25: 51447328932137, 50: 51447328964905, 75: 51447328997673, 100: 51447329030441, 125: 51447329063209 },
      ptz33: { none: 51447392665897, 25: 51447392698665, 50: 51447392731433, 75: 51447392764201, 100: 51447392796969, 125: 51447392829737 },
      dv4: (CC_REAL.cameras && CC_REAL.cameras.dv4) || null, // 4x Dual View PTZ — ids supplied by cc-page-build.liquid
      dv25: (CC_REAL.cameras && CC_REAL.cameras.dv25) || null // 25x Dual View PTZ — ids supplied by cc-page-build.liquid
    },
    // Used for locations beyond what a popular kit's own variants cover (e.g. a 4th+ location).
    locationAddon: CC_REAL.locationAddon || null, // Extra Location add-on — id supplied by cc-page-build.liquid via all_products['extra-location-building-or-pole']
    wireSurcharge: {
      25: 49007373418793,
      50: 49007373517097,
      75: 51469561430313,
      100: 51515808153897,
      125: 51515808514345
    }
  };

  var STORAGE_KEY = "cattlecams.build.v1";

  function findCamera(id) {
    for (var i = 0; i < CAMERAS.length; i++) if (CAMERAS[i].id === id) return CAMERAS[i];
    return null;
  }
  function findPopularKit(id) {
    for (var i = 0; i < POPULAR_KITS.length; i++) if (POPULAR_KITS[i].id === id) return POPULAR_KITS[i];
    return null;
  }

  function loadSaved() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      return data && typeof data === "object" ? data : null;
    } catch (e) {
      return null;
    }
  }

  var saved = loadSaved();
  var state = {
    kitId: saved && "kitId" in saved ? saved.kitId : "standard",
    popularKit: saved && saved.popularKit ? saved.popularKit : null,
    items: saved && Array.isArray(saved.items) ? saved.items : [],
    extraLocations: saved && typeof saved.extraLocations === "number" ? saved.extraLocations : 0,
    kitWires: saved && Array.isArray(saved.kitWires) ? saved.kitWires : [],
    wireMode: "addon",
    wireFor: null,
    wireFt: null,
    kitWireIdx: 0,
    pendingPick: null
  };

  function persist() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        kitId: state.kitId,
        popularKit: state.popularKit,
        items: state.items,
        extraLocations: state.extraLocations,
        kitWires: state.kitWires
      }));
    } catch (e) {}
  }

  function subtotal() {
    var total = 0;
    if (state.popularKit) total += state.popularKit.numericPrice || 0;
    else total += KIT.numericPrice;
    total += state.extraLocations * LOCATION_ADDON_PRICE;
    state.items.forEach(function(it) {
      var c = findCamera(it.camId);
      if (c) total += c.numericPrice;
      if (typeof it.wireFt === "number") total += WIRE_PRICE[it.wireFt] || 0;
    });
    state.kitWires.forEach(function(kw) {
      if (typeof kw.wireFt === "number") total += WIRE_PRICE[kw.wireFt] || 0;
    });
    return total;
  }

  // ---- DOM refs ----
  var els = {
    stepKitTitle: document.getElementById("step-kit-title"),
    stepKitSub: document.getElementById("step-kit-sub"),
    kitChoiceStandard: document.getElementById("kit-choice-standard"),
    kitChoicePopular: document.getElementById("kit-choice-popular"),
    popularKitName: document.getElementById("popular-kit-name"),
    popularKitWhen: document.getElementById("popular-kit-when"),
    popularKitPrice: document.getElementById("popular-kit-price"),
    popularKitIncludes: document.getElementById("popular-kit-includes"),
    kitSwitchBtn: document.getElementById("kit-switch-btn"),
    locNum: document.getElementById("loc-num"),
    locMinus: document.getElementById("loc-minus"),
    locPlus: document.getElementById("loc-plus"),
    locPrice: document.getElementById("loc-price"),
    sidebarLines: document.getElementById("build-sidebar-lines"),
    checkoutBtn: document.getElementById("build-checkout"),
    banner: document.getElementById("picked-banner"),
    bannerCam: document.getElementById("picked-banner-cam"),
    bannerWire: document.getElementById("picked-banner-wire"),
    bannerNote: document.getElementById("picked-banner-note"),
    bannerClose: document.getElementById("picked-banner-close")
  };

  var wireModal = document.getElementById("wire-overlay");
  if (!wireModal) return;
  var wmCable = wireModal.querySelector("[data-wm-cable]");
  var wmCamera = wireModal.querySelector("[data-wm-camera]");
  var wmMeasL1 = wireModal.querySelector("[data-wm-meas-l1]");
  var wmMeasR = wireModal.querySelector("[data-wm-meas-r]");
  var wmMeasText = wireModal.querySelector("[data-wm-meas-text]");
  var wmMeasSub = wireModal.querySelector("[data-wm-meas-sub]");
  var wmRunLabel = wireModal.querySelector("[data-wm-runlabel]");
  var wmOptions = Array.prototype.slice.call(wireModal.querySelectorAll("[data-wm-ft]"));
  var wmConfirm = document.getElementById("wire-confirm");
  var wmConfirmLabel = document.getElementById("wire-confirm-label");
  var wmCancel = document.getElementById("wire-cancel");
  var addonBlock = wireModal.querySelector('[data-wire-mode="addon"]');
  var kitBlock = wireModal.querySelector('[data-wire-mode="kit"]');
  var wmCamNameAddon = document.getElementById("wire-cam-name-addon");
  var wmCamNameKit = document.getElementById("wire-cam-name-kit");
  var wmKitStepLabel = document.getElementById("wire-kit-step-label");
  var wmKitHelper = document.getElementById("wire-kit-helper");

  // ---- Render ----
  function renderStep1() {
    if (state.popularKit) {
      els.stepKitTitle.textContent = "Your Base Kit — " + state.popularKit.name;
      els.stepKitSub.textContent = "You picked one of our best-seller kits below — pre-built bundle with cameras, the bridge, the recorder, and all the cables. Wired up and tested before it ships.";
      els.kitChoiceStandard.hidden = true;
      els.kitChoicePopular.hidden = false;
      els.popularKitName.textContent = state.popularKit.name;
      els.popularKitWhen.textContent = state.popularKit.when;
      els.popularKitPrice.textContent = state.popularKit.price;
      els.popularKitIncludes.innerHTML = state.popularKit.includes.map(function(i) {
        return "<li>" + i + "</li>";
      }).join("");
      els.kitSwitchBtn.hidden = false;
    } else {
      els.stepKitTitle.textContent = "Your Base Kit (already included)";
      els.stepKitSub.textContent = "The foundation — bridge antenna, receiver hub, weatherproof wiring parts, and 1-on-1 setup support. Every system starts here.";
      els.kitChoiceStandard.hidden = false;
      els.kitChoicePopular.hidden = true;
      els.kitSwitchBtn.hidden = true;
    }
  }

  function renderStep2() {
    els.locNum.textContent = state.extraLocations;
    els.locMinus.disabled = state.extraLocations === 0;
    els.locPrice.textContent = state.extraLocations > 0
      ? "+$" + (state.extraLocations * LOCATION_ADDON_PRICE).toLocaleString()
      : "$350 ea";
  }

  function renderStep3() {
    CAMERAS.forEach(function(c) {
      var picked = state.items.filter(function(i) { return i.camId === c.id; }).length;
      var card = document.querySelector('.cc-cam-pick[data-cam-id="' + c.id + '"]');
      if (!card) return;
      card.querySelector("[data-step-val]").textContent = picked;
      card.querySelector("[data-step-minus]").disabled = picked === 0;
    });
  }

  function renderBanner() {
    if (!state.pendingPick) {
      els.banner.hidden = true;
      return;
    }
    els.banner.hidden = false;
    els.bannerCam.textContent = state.pendingPick.camName;
    els.bannerWire.textContent = state.pendingPick.wire + "ft wire run";
    els.bannerNote.hidden = !state.pendingPick.unmatched;
  }

  function renderSidebar() {
    var html = "";
    var empty = state.items.length === 0 && !state.extraLocations && !state.popularKit;

    if (state.popularKit) {
      html += '<div class="cc-build-line cc-build-line-fixed"><div>' +
        '<div class="cc-name">' + state.popularKit.name + ' <span class="cc-line-tag">Best Seller Kit</span></div>' +
        '<div class="cc-sub">' + state.popularKit.tagline + ' · Pre-built, tested, ready to ship</div>' +
        '<button type="button" class="cc-rm" data-action="clear-popular-kit">Switch to build my own</button>' +
        '</div><div class="cc-px">' + state.popularKit.price + '</div></div>';
    } else {
      html += '<div class="cc-build-line cc-build-line-fixed"><div>' +
        '<div class="cc-name">' + KIT.name + ' <span class="cc-line-tag">Included</span></div>' +
        '<div class="cc-sub">Antenna · receiver · setup support</div>' +
        '</div><div class="cc-px">' + KIT.price + '</div></div>';
    }

    if (state.popularKit && state.kitWires.length > 0) {
      var remaining = state.kitWires.filter(function(w) { return typeof w.wireFt !== "number"; }).length;
      html += '<div class="cc-kit-cables-block"><div class="cc-kit-cables-head"><span>Cables for your kit</span>' +
        (remaining > 0 ? '<span class="cc-kit-cables-warn">' + remaining + ' to pick</span>' : "") +
        '</div>';
      state.kitWires.forEach(function(kw, i) {
        var cam = findCamera(kw.camId);
        var isPicked = typeof kw.wireFt === "number";
        html += '<div class="cc-kit-cable-row' + (isPicked ? "" : " cc-is-missing") + '">' +
          '<div class="cc-kit-cable-meta">' +
          '<div class="cc-kit-cable-cam">Cable ' + (i + 1) + ' · ' + (cam ? cam.name : kw.camId) + '</div>' +
          '<div class="cc-kit-cable-len">' +
          (isPicked ? kw.wireFt + 'ft wire run · +$' + (WIRE_PRICE[kw.wireFt] || 0) : 'Length not picked yet') +
          '</div></div>' +
          '<button type="button" class="cc-kit-cable-edit" data-action="edit-kit-cable" data-idx="' + i + '">' +
          (isPicked ? "Change" : "Pick") + '</button></div>';
      });
      html += "</div>";
    }

    if (state.extraLocations > 0) {
      html += '<div class="cc-build-line"><div>' +
        '<div class="cc-name">' + state.extraLocations + '× Remote Location Add-On</div>' +
        '<div class="cc-sub">Remote bridge antenna · ' + (state.extraLocations + 1) + ' locations total</div>' +
        '<button type="button" class="cc-rm" data-action="clear-locations">Remove</button>' +
        '</div><div class="cc-px">$' + (state.extraLocations * LOCATION_ADDON_PRICE).toLocaleString() + '</div></div>';
    }

    state.items.forEach(function(it) {
      var c = findCamera(it.camId);
      if (!c) return;
      var wirePx = typeof it.wireFt === "number" ? (WIRE_PRICE[it.wireFt] || 0) : 0;
      var wireLabel = it.wireFt + "ft wire run · +$" + wirePx;
      var lineTotal = c.numericPrice + wirePx;
      html += '<div class="cc-build-line"><div>' +
        '<div class="cc-name">' + c.name + '</div>' +
        '<div class="cc-sub">' + c.tagline + ' · ' + wireLabel + '</div>' +
        '<button type="button" class="cc-rm" data-action="remove-item" data-uid="' + it.uid + '">Remove</button>' +
        '</div><div class="cc-px">$' + lineTotal.toLocaleString() + '</div></div>';
    });

    var total = subtotal();
    html += '<div class="cc-build-total"><div><div class="cc-lab">Subtotal · one-time</div></div>' +
      '<div class="cc-num">' + (total > 0 ? "$" + total.toLocaleString() : "—") + '</div></div>';
    html += '<div class="cc-subtotal-sub">$0/mo · forever</div>';

    els.sidebarLines.innerHTML = html;
    els.checkoutBtn.disabled = empty;
    els.checkoutBtn.innerHTML = empty ? "Build your setup first" : 'Add to cart <span class="cc-arr">→</span>';
  }

  function render() {
    renderStep1();
    renderStep2();
    renderStep3();
    renderSidebar();
    renderBanner();
    persist();
  }

  // ---- Wire overlay ----
  function updateDiagram(ft) {
    var fmin = 25, fmax = 125;
    var safe = typeof ft === "number" ? ft : 50;
    var t = Math.min(1, Math.max(0, (safe - fmin) / (fmax - fmin)));
    var outletX = 56;
    var camX = 150 + t * 180;
    var sag = 14 + t * 30;
    var xStart = 74;
    var xEnd = camX - 22;
    var mid = (xStart + xEnd) / 2;
    wmCable.setAttribute("d", "M " + xStart + " 107 C " + (mid - 24) + " " + (107 + sag) + ", " + (mid + 24) + " " + (107 + sag) + ", " + xEnd + " 99");
    wmCamera.setAttribute("transform", "translate(" + camX + " 96)");
    wmMeasL1.setAttribute("x2", camX);
    wmMeasR.setAttribute("x1", camX);
    wmMeasR.setAttribute("x2", camX);
    var midX = (outletX + camX) / 2;
    wmMeasText.setAttribute("x", midX);
    wmMeasText.textContent = typeof ft === "number" ? ft + " FT" : "—";
    if (wmMeasSub) wmMeasSub.setAttribute("x", midX);
  }

  function setWireFt(ft) {
    state.wireFt = ft;
    wmOptions.forEach(function(b) {
      b.classList.toggle("cc-is-selected", String(b.dataset.wmFt) === String(ft));
    });
    var numeric = typeof ft === "number";
    wmRunLabel.textContent = numeric ? ft + " feet" : "—";
    updateDiagram(ft);
    wmConfirm.disabled = ft == null;
    wmConfirm.style.opacity = ft == null ? 0.5 : 1;
    wmConfirm.style.pointerEvents = ft == null ? "none" : "auto";
  }

  function openWireOverlay() {
    var cam = findCamera(state.wireFor);
    if (!cam) return;
    if (state.wireMode === "kit") {
      addonBlock.hidden = true;
      kitBlock.hidden = false;
      wmKitStepLabel.textContent = "Cable " + (state.kitWireIdx + 1) + " of " + state.kitWires.length + " · " + (state.popularKit ? state.popularKit.name : "Your kit");
      wmCamNameKit.textContent = cam.name;
      wmKitHelper.textContent = "Your kit ships with the cameras, bridge, and recorder pre-built — you just pick how long each camera's power cable needs to be." +
        (state.kitWires.length > 1 ? " We'll walk through all " + state.kitWires.length + " cameras one at a time." : "");
      var isLast = state.kitWireIdx + 1 === state.kitWires.length;
      wmConfirmLabel.textContent = isLast ? "Save cable & finish" : "Save & next cable";
      wmCancel.textContent = "Pick later";
      wireModal.setAttribute("aria-labelledby", "wire-overlay-title-kit");
    } else {
      addonBlock.hidden = false;
      kitBlock.hidden = true;
      wmCamNameAddon.textContent = cam.name;
      wmConfirmLabel.textContent = "Add " + cam.name + " to build";
      wmCancel.textContent = "Cancel";
      wireModal.setAttribute("aria-labelledby", "wire-overlay-title-addon");
    }
    setWireFt(state.wireFt);
    wireModal.hidden = false;
    wireModal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  function closeWireOverlay() {
    wireModal.hidden = true;
    wireModal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  function startAddCamera(camId) {
    state.wireMode = "addon";
    state.wireFor = camId;
    state.wireFt = null;
    openWireOverlay();
  }

  function startKitFlow(kit) {
    state.popularKit = kit;
    state.items = [];
    var expanded = [];
    (kit.cams || []).forEach(function(c) {
      for (var i = 0; i < (c.count || 0); i++) expanded.push(c.camId);
    });
    state.kitWires = expanded.map(function(camId) { return { camId: camId, wireFt: null }; });
    if (expanded.length > 0) {
      state.wireMode = "kit";
      state.kitWireIdx = 0;
      state.wireFor = expanded[0];
      state.wireFt = null;
      openWireOverlay();
    }
    render();
  }

  function openKitCablePicker(idx) {
    if (idx < 0 || idx >= state.kitWires.length) return;
    state.wireMode = "kit";
    state.kitWireIdx = idx;
    state.wireFor = state.kitWires[idx].camId;
    state.wireFt = typeof state.kitWires[idx].wireFt === "number" ? state.kitWires[idx].wireFt : null;
    openWireOverlay();
  }

  function confirmAdd() {
    if (!state.wireFor || state.wireFt == null) return;
    if (state.wireMode === "kit") {
      state.kitWires[state.kitWireIdx] = { camId: state.kitWires[state.kitWireIdx].camId, wireFt: state.wireFt };
      var nextIdx = state.kitWireIdx + 1;
      if (nextIdx < state.kitWires.length) {
        state.kitWireIdx = nextIdx;
        state.wireFor = state.kitWires[nextIdx].camId;
        state.wireFt = null;
        openWireOverlay();
      } else {
        state.wireFor = null;
        state.wireFt = null;
        state.wireMode = "addon";
        state.kitWireIdx = 0;
        closeWireOverlay();
      }
      render();
      return;
    }
    state.items.push({
      uid: crypto.randomUUID ? crypto.randomUUID() : "pick-" + Math.random(),
      camId: state.wireFor,
      wireFt: state.wireFt
    });
    state.wireFor = null;
    state.wireFt = null;
    closeWireOverlay();
    render();
  }

  function cancelWire() {
    state.wireFor = null;
    state.wireFt = null;
    state.wireMode = "addon";
    closeWireOverlay();
  }

  function removeOneOfCam(camId) {
    var idx = -1;
    state.items.forEach(function(it, i) { if (it.camId === camId) idx = i; });
    if (idx === -1) return;
    state.items.splice(idx, 1);
    render();
  }

  function removeItem(uid) {
    state.items = state.items.filter(function(it) { return it.uid !== uid; });
    render();
  }

  function scrollToBuild() {
    var el = document.getElementById("build");
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: top, behavior: "smooth" });
  }

  // ---- Add to cart ----
  function buildSummary() {
    return {
      kit: state.popularKit ? state.popularKit.name : KIT.name,
      extraLocations: state.extraLocations,
      items: state.items.map(function(it) {
        var c = findCamera(it.camId);
        return { camera: c ? c.name : it.camId, wireFt: it.wireFt };
      }),
      kitWires: state.kitWires.map(function(kw) {
        var c = findCamera(kw.camId);
        return { camera: c ? c.name : kw.camId, wireFt: kw.wireFt };
      }),
      subtotal: subtotal()
    };
  }

  function addToCart() {
    var empty = state.items.length === 0 && !state.extraLocations && !state.popularKit;
    if (empty) return;

    var lineItems = [];

    if (state.popularKit) {
      var kitVariants = CC_VARIANTS.popularKits[state.popularKit.id] || {};
      var kitMaxLocations = Math.max.apply(null, Object.keys(kitVariants).map(Number));
      var wantedLocations = 1 + state.extraLocations;
      var kitLocations = Math.min(wantedLocations, kitMaxLocations);
      var overflowLocations = wantedLocations - kitLocations;

      lineItems.push({ id: kitVariants[kitLocations], quantity: 1, properties: { "Kit": state.popularKit.name } });

      if (overflowLocations > 0) {
        lineItems.push({ id: CC_VARIANTS.locationAddon, quantity: overflowLocations, properties: {} });
      }

      state.kitWires.forEach(function(kw) {
        if (typeof kw.wireFt === "number") {
          var cam = findCamera(kw.camId);
          lineItems.push({
            id: CC_VARIANTS.wireSurcharge[kw.wireFt],
            quantity: 1,
            properties: { "Wire Run": kw.wireFt + "ft", "For Camera": cam ? cam.name : kw.camId }
          });
        }
      });
    } else {
      lineItems.push({ id: CC_VARIANTS.kit, quantity: 1, properties: {} });

      if (state.extraLocations > 0) {
        lineItems.push({ id: CC_VARIANTS.locationAddon, quantity: state.extraLocations, properties: {} });
      }
    }

    state.items.forEach(function(it) {
      var props = {};
      var wireKey = typeof it.wireFt === "number" ? it.wireFt : "none";
      if (typeof it.wireFt === "number") props["Wire Run"] = it.wireFt + "ft";
      var camVariants = CC_VARIANTS.cameras[it.camId] || {};
      lineItems.push({ id: camVariants[wireKey], quantity: 1, properties: props });
    });

    var missing = lineItems.filter(function(li) { return !li.id; });
    if (missing.length) {
      console.error("Cattle Cams builder: missing Shopify variant ID(s) in CC_VARIANTS — wire these up in cc-build.js before launch.", missing);
      alert("This setup isn't fully connected to Shopify yet (missing product IDs). Check the browser console, or call (605) 622-0676 to order this setup directly.");
      return;
    }

    els.checkoutBtn.disabled = true;
    els.checkoutBtn.innerHTML = "Adding…";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({
        items: lineItems,
        attributes: { "Cattle Cams Build": JSON.stringify(buildSummary()) }
      })
    })
      .then(function(r) {
        if (!r.ok) return r.json().then(function(e) { throw e; });
        return r.json();
      })
      .then(function() {
        window.location.href = "/cart";
      })
      .catch(function(err) {
        console.error("Add to cart failed", err);
        alert("Couldn't add this to your cart. Please try again, or call (605) 622-0676.");
        render();
      });
  }

  // ---- Event wiring ----
  CAMERAS.forEach(function(c) {
    var card = document.querySelector('.cc-cam-pick[data-cam-id="' + c.id + '"]');
    if (!card) return;
    card.querySelector("[data-step-minus]").addEventListener("click", function() { removeOneOfCam(c.id); });
    card.querySelector("[data-step-plus]").addEventListener("click", function() { startAddCamera(c.id); });
  });

  els.locMinus.addEventListener("click", function() {
    state.extraLocations = Math.max(0, state.extraLocations - 1);
    render();
  });
  els.locPlus.addEventListener("click", function() {
    state.extraLocations = Math.min(8, state.extraLocations + 1);
    render();
  });

  els.kitSwitchBtn.addEventListener("click", function() {
    state.popularKit = null;
    state.kitWires = [];
    state.wireMode = "addon";
    state.wireFor = null;
    state.wireFt = null;
    render();
  });

  els.sidebarLines.addEventListener("click", function(e) {
    var btn = e.target.closest("[data-action]");
    if (!btn) return;
    var action = btn.dataset.action;
    if (action === "remove-item") removeItem(btn.dataset.uid);
    else if (action === "clear-locations") { state.extraLocations = 0; render(); }
    else if (action === "clear-popular-kit") {
      state.popularKit = null;
      state.kitWires = [];
      state.wireMode = "addon";
      state.wireFor = null;
      state.wireFt = null;
      render();
    } else if (action === "edit-kit-cable") {
      openKitCablePicker(parseInt(btn.dataset.idx, 10));
    }
  });

  wmOptions.forEach(function(b) {
    b.addEventListener("click", function() {
      var raw = b.dataset.wmFt;
      setWireFt(parseInt(raw, 10));
      confirmAdd();
    });
  });
  wmCancel.addEventListener("click", cancelWire);
  wireModal.addEventListener("click", function(e) { if (e.target === wireModal) cancelWire(); });
  document.addEventListener("keydown", function(e) { if (!wireModal.hidden && e.key === "Escape") cancelWire(); });
  wmConfirm.addEventListener("click", confirmAdd);

  document.querySelectorAll("[data-popular-kit]").forEach(function(btn) {
    btn.addEventListener("click", function() {
      var kit = findPopularKit(btn.dataset.popularKit);
      if (!kit) return;
      startKitFlow(kit);
      scrollToBuild();
    });
  });

  els.bannerClose.addEventListener("click", function() {
    state.pendingPick = null;
    render();
  });

  els.checkoutBtn.addEventListener("click", addToCart);

  // ---- URL param handoff (?kit=, ?cam=&wire=) ----
  (function handleUrlParams() {
    var params = new URLSearchParams(window.location.search);
    var kitParam = params.get("kit");
    var camName = params.get("cam");
    var camIdParam = params.get("camId");
    var wireRaw = params.get("wire");
    var changed = false;

    if (kitParam) {
      var match = findPopularKit(kitParam);
      if (match) startKitFlow(match);
      changed = true;
    }

    if (camName && wireRaw) {
      var wire = parseInt(wireRaw, 10);
      var matched = camIdParam ? findCamera(camIdParam) : null;
      if (!matched) {
        var m = camName.match(/(\d+)\s*x/i);
        if (m) {
          var num = m[1];
          matched = CAMERAS.filter(function(c) { return new RegExp("^" + num + "x", "i").test(c.name); })[0];
        }
      }
      if (matched && typeof wire === "number") {
        state.items.push({
          uid: crypto.randomUUID ? crypto.randomUUID() : "pick-" + Math.random(),
          camId: matched.id,
          wireFt: wire
        });
        state.pendingPick = { camName: camName, wire: wire };
      } else {
        state.pendingPick = { camName: camName, wire: wire, unmatched: true };
      }
      changed = true;
    }

    if (changed) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete("kit");
        url.searchParams.delete("cam");
        url.searchParams.delete("camId");
        url.searchParams.delete("wire");
        window.history.replaceState({}, "", url.toString());
      } catch (e) {}
      setTimeout(scrollToBuild, 60);
    }
  })();

  render();
})();
